/**
 * Vue i18n plugin
 * Makes translation functions available in all Vue components
 */

import { __, s__, n__, sprintf } from '../locale'

export default {
  install(app) {
    // Add translation methods to global properties
    app.config.globalProperties.__ = __
    app.config.globalProperties.s__ = s__
    app.config.globalProperties.n__ = n__
    app.config.globalProperties.sprintf = sprintf

    // Also provide them via provide/inject
    app.provide('__', __)
    app.provide('s__', s__)
    app.provide('n__', n__)
    app.provide('sprintf', sprintf)
  },
}
